import { render, staticRenderFns } from "./approveRecord.vue?vue&type=template&id=c2bccd10&scoped=true"
import script from "./approveRecord.vue?vue&type=script&lang=js"
export * from "./approveRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bccd10",
  null
  
)

export default component.exports